// extracted by mini-css-extract-plugin
var _1 = "DraggablePanel_collapsed__ab135";
var _2 = "DraggablePanel_content__703f6";
var _3 = "DraggablePanel_contentWrapper__06372";
var _4 = "DraggablePanel_header__12409";
var _5 = "DraggablePanel_icons__110e8";
var _6 = "DraggablePanel_label__3617d";
var _7 = "DraggablePanel_popover__f3cfa";
var _8 = "DraggablePanel_wrapper__c96e3";
export { _1 as "collapsed", _2 as "content", _3 as "contentWrapper", _4 as "header", _5 as "icons", _6 as "label", _7 as "popover", _8 as "wrapper" }
